import { z } from 'zod';

/**
 * Schéma du formulaire item de grille tarifaire (modal /admin/pricing).
 * Le montant est saisi en EUROS (input number) et converti en centimes
 * au submit (eurosToCents) — le kind est fixé par la section d'origine,
 * il ne passe pas par le formulaire.
 */
export const pricingItemFormSchema = z.object({
  label: z.string().trim().min(1, 'Le libellé est requis').max(200, 'Le libellé est trop long'),
  code: z
    .string()
    .max(100, 'Le code est trop long')
    .regex(/^[a-z0-9_]*$/, 'Minuscules, chiffres et _ uniquement')
    .optional()
    .or(z.literal('')),
  amount_euros: z
    .number({ error: 'Le montant est requis' })
    .positive('Le montant doit être positif')
    .refine((v) => Math.abs(v * 100 - Math.round(v * 100)) < 1e-6, 'Maximum 2 décimales'),
  // Document de conditions (assurance) — fourni tardivement par l'assureur
  // chaque année. Renseigné => le tunnel BED exige la certification de
  // lecture avant tout paiement (gate 00164). HTTPS strict (rendu en <a href>
  // côté participant — CHECK miroir en DB, 00164).
  conditions_url: z
    .string()
    .trim()
    .url('URL invalide (https://…)')
    .refine((v) => v.startsWith('https://'), 'URL invalide (https://…)')
    .optional()
    .or(z.literal('')),
});

export type PricingItemFormValues = z.infer<typeof pricingItemFormSchema>;
